import {
  useGetAnswerByIdLazyQuery,
} from "graphql/__generated__/hooks";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Answer } from "types/answer";

export const useAnswerDetail = () => {
  const { answerId, organizationId } = useParams();
  const [getAnswerById, { data, loading }] = useGetAnswerByIdLazyQuery();

  const answer = useMemo<Answer | null>(() => {
    if (!data?.answer_by_pk) return null;
    const ans = data.answer_by_pk;
    return {
      answer_id: ans.answer_id,
      answer: ans.answer,
      option_id: ans.option_id || undefined,
      question_id: ans.question_id,
      option: ans.option ? {
        option_id: ans.option.option_id,
        order: ans.option.order,
        question_id: ans.option.question_id,
        text: ans.option.text,
      } : undefined,
      question: ans.question ? {
        question_id: ans.question.question_id,
        title: ans.question.title,
        type: ans.question.type,
        body: ans.question.body,
        order: ans.question.order,
      } : undefined,
    };
  }, [data]);

  useEffect(() => {
    if (answerId) {
      getAnswerById({ variables: { answerId } });
    }
  }, [answerId, getAnswerById]);

  return {
    answer,
    loading,
    organizationId,
  };
};
